import {
  WEEKS_CREATE_FAIL,
  WEEKS_CREATE_REQUEST,
  WEEKS_CREATE_SUCCESS,
  WEEKS_LIST_FAIL,
  WEEKS_LIST_REQUEST,
  WEEKS_LIST_SUCCESS,
  WEEKS_UPDATE_FAIL,
  WEEKS_UPDATE_REQUEST,
  WEEKS_UPDATE_SUCCESS,
  WEEKS_PATCH_FAIL,
  WEEKS_PATCH_REQUEST,
  WEEKS_PATCH_SUCCESS,
  WEEKS_SINGLE_FAIL,
  WEEKS_SINGLE_REQUEST,
  WEEKS_SINGLE_SUCCESS,
} from "../constants/weekConstants";

export const weeksCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case WEEKS_CREATE_REQUEST:
      return { loading: true };
    case WEEKS_CREATE_SUCCESS:
      return { loading: false, success: true };
    case WEEKS_CREATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const weekListReducer = (state = { weeks: [] }, action) => {
  switch (action.type) {
    case WEEKS_LIST_REQUEST:
      return { loading: true };
    case WEEKS_LIST_SUCCESS:
      return { loading: false, weeks: action.payload };
    case WEEKS_LIST_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const weekSingleReducer = (
  state = { week: null, version: 0, fieldMeta: {} },
  action,
) => {
  switch (action.type) {
    case WEEKS_SINGLE_REQUEST:
      return { loading: true, version: 0, fieldMeta: {} };
    case WEEKS_SINGLE_SUCCESS: {
      // The Week GET response is { objectives, columnOrder, _version,
      // _fieldMeta } — we keep the inner shape (objectives + columnOrder)
      // on `week` so existing consumers keep working, and lift the meta
      // out alongside.
      const payload = action.payload || {};
      const { _version, _fieldMeta, ...flat } = payload;
      return {
        loading: false,
        week: flat,
        version: typeof _version === "number" ? _version : 0,
        fieldMeta: _fieldMeta || {},
      };
    }
    case WEEKS_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case WEEKS_PATCH_REQUEST:
      return { ...state, patchInflight: true };
    case WEEKS_PATCH_SUCCESS: {
      const payload = action.payload || {};
      return {
        ...state,
        patchInflight: false,
        version:
          typeof payload.version === "number" ? payload.version : state.version,
        fieldMeta: payload.fieldMeta || state.fieldMeta,
        patchError: undefined,
      };
    }
    case WEEKS_PATCH_FAIL:
      return { ...state, patchInflight: false, patchError: action.payload };
    default:
      return state;
  }
};

export const weekUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case WEEKS_UPDATE_REQUEST:
      return { loading: true };
    case WEEKS_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case WEEKS_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
